module services {
    export module tariff {
        export class customsOfficeCodeService implements interfaces.tariff.ICustomsOfficeCodeService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            getForDropdown(searchText: string, countryId?: number): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "CustomsOfficeCode/GetForDropdown", {
                    countryId: countryId,
                    searchText: searchText
                });
            }
        }
    }
    angular.module("app").service("customsOfficeCodeService", services.tariff.customsOfficeCodeService);
}